import { render, staticRenderFns } from "./GiftCartItem.vue?vue&type=template&id=7cb66c0c"
import script from "./GiftCartItem.vue?vue&type=script&lang=js"
export * from "./GiftCartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports